export default __webpack_public_path__ + "static/media/searchicon.338d4e7b.svg";